import React, { useCallback, useState, useEffect } from "react";
import UserDashboardnav from "components/nav/userdashboard";
import Footer from "components/nav/footer.component";
import ServiceSearch from "components/services/search.component";
import { useSearchParams } from "react-router-dom";
import useDebounce from "utils/hooks/useDebounce";
import { selectCurrentUser } from "store/user/user.selector";
import { useSelector } from "react-redux";
import { apiRequest } from "utils/helper/helper";
import { hostURL } from "utils/helper/states";
import Providers from "components/services/providers.component";
import { Business, House } from "store/service/service.types";

const Subcategory: React.FC<{ isHouse: boolean }> = ({ isHouse }) => {
  // const location = useLocation();

  // const isHouse: boolean = location.state!.isHouse;

  const [providers, setProviders] = useState<Business[] | House[] | null>(null);
  const [searchValue, setSearchValue] = useState("");
  const deBounceValue = useDebounce(searchValue, 1000);
  const [searchParams] = useSearchParams();
  const title = searchParams.get("service");
  const emptyServices = new Array(20).fill(0);
  const user = useSelector(selectCurrentUser);

  const filteredHouse = !isHouse
    ? []
    : providers == null
    ? providers
    : (providers as House[]).filter((service) =>
        (service as House).title

          .toLowerCase()
          .includes(deBounceValue.toLowerCase())
      );

  const filteredProviders = isHouse
    ? []
    : providers == null
    ? providers
    : (providers as Business[]).filter((service) =>
        (service as Business).businessName
          .toLowerCase()
          .includes(deBounceValue.toLowerCase())
      );

  const fetchServiceProviders = useCallback(async () => {
    if (!user) return;

    try {
      const uri = isHouse
        ? `${hostURL}/api/agents/get-houses`
        : `${hostURL}/api/services/get-service-providers?service=${title}`;
      const data = await apiRequest(uri, user.token);
      console.log("-----DATA-----\n", data);
      setProviders(data);
    } catch (error) {
      console.error("Error fetching service providers:", error);
    }
  }, [isHouse, title, user]);

  useEffect(() => {
    fetchServiceProviders();
  }, [fetchServiceProviders]);

  return (
    <section className="w-full">
      <UserDashboardnav />
      <main className="w-full pb-24 px-6 xl:px-24">
        <div className="mt-12">
          <h1 className="capitalize text-3xl font-normal mb-7">
            Search nearby
          </h1>
          <div className="relative w-full">
            <div className="w-full px-6 lg:px-12">
              <ServiceSearch
                searchValue={searchValue}
                handleChange={setSearchValue}
              />
            </div>
          </div>
        </div>
        <div className="flex justify-center p-8">
          <h1 className="capitalize font-semibold mt-22 text-2xl">
            {isHouse ? "Houses" : `${title} category`}
          </h1>
        </div>
        {isHouse ? (
          <Providers
            houses={filteredHouse as House[]}
            emptyServices={emptyServices}
          />
        ) : (
          <Providers
            providers={filteredProviders as Business[]}
            emptyServices={emptyServices}
          />
        )}
      </main>
      <Footer />
    </section>
  );
};

export default Subcategory;
